import { Store, Module, ActionContext } from 'vuex'
import Ajax from '../../lib/ajax'
import ListModule from './list-module'
import PageResult from '@/store/entities/page-result';
import IntoLogisticsList from '../entities/intologisticsrecord'
import ListState from './list-state'

interface FrontIntoLogisticsListState extends ListState<IntoLogisticsList> {
    IntoLogisticsInfo: IntoLogisticsList,
}

class FrontIntoLogistics extends ListModule<FrontIntoLogisticsListState, any, IntoLogisticsList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<IntoLogisticsList>(),
        loading: false,
        intologisticsInfo: IntoLogisticsList,


    }
    actions = {
        async getAll(context: ActionContext<FrontIntoLogisticsListState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/UserExpressInfo/GetIntoLogisticsList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<IntoLogisticsList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: FrontIntoLogisticsListState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontIntoLogisticsListState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const frontintologistics = new FrontIntoLogistics();
export default frontintologistics;